import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

import { LoginComponent } from './auth/login/login.component';
import { CrmModule } from './modules/crm/crm.module';

@NgModule({
  declarations: [LoginComponent],
  imports: [CommonModule, ProgressSpinnerModule, CrmModule],
  exports: [LoginComponent, CrmModule],
})
export class AppModule {}
